module.exports = __webpack_public_path__ + "static/ico-03-28617d08bc6c36cafea0d8a9ee880160.svg";